import React from 'react';
import NumberFormat from 'react-number-format';

interface INumberFormatCustomProps {
  inputRef: (instance: NumberFormat<number> | null) => void;
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  format: any;
  min?: number;
  max?: number;
}

function NumberFormatCustom(props: INumberFormatCustomProps) {
  const { inputRef, onChange, format, name, min, max, ...other } = props;

  const handleChange = ({ value }: any) => {
    let newValue = value;
    if (newValue !== '' && !Number.isNaN(Number(newValue))) {
      const numValue = Number(newValue);
      if (typeof min === 'number' && numValue < min) {
        newValue = String(min);
      }
      if (typeof max === 'number' && numValue > max) {
        newValue = String(max);
      }
    }
    onChange({
      target: {
        name,
        value: newValue,
      },
    });
  };

  return (
    <NumberFormat
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...other}
      name={name}
      getInputRef={inputRef}
      onValueChange={handleChange}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...format}
    />
  );
}

export default NumberFormatCustom;
